import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
  name: 'product-stock',
  namespaced: true,
  state,
  actions,
  mutations,
};
